import { call, put, takeLatest, delay } from "redux-saga/effects";
import { push } from 'connected-react-router'
import ActionTypeConstants from "helpers/ActionTypeConstants";
import { actionApiCall } from "helpers/api/ApiCalls";

/**
 * Add user account from Add form submission
 */
function* RevokeUserAccessSaga({ payload }) {
    try {
        const apiResponse = yield call(actionApiCall, {
            actionType: ActionTypeConstants.REVOKE_USER_ACCESS,
            data: { 
                id: payload.id
            }
        });
        if (apiResponse.res.data.response === 200) {
            yield put({
                type: ActionTypeConstants.LOAD_USERS,
                payload: {
                    inactive: true,
                }
            });
            yield put(push('/maintain/users'));
            yield put({
                type: ActionTypeConstants.SHOW_ALERT,
                payload: {
                    message: apiResponse.res.message || "Account access revoked!",
                    color: "success"
                }
            });
            yield delay(10000)
            yield put({ type: ActionTypeConstants.HIDE_ALERT });      
        } else {
            yield put({
                type: ActionTypeConstants.SHOW_ALERT,
                payload: {
                    message: apiResponse.res.data.message || "Error - Account access revoke failed!",
                    color: "danger"
                }
            });
            yield delay(10000)
            yield put({
                type: ActionTypeConstants.HIDE_ALERT
            });
        }
    } catch (err) {
        yield put({
            type: ActionTypeConstants.SHOW_ALERT,
            payload: {
                message: "Error - Account delete failed!",
                color: "danger"
            }
        });
        yield delay(10000)
        yield put({ type: ActionTypeConstants.HIDE_ALERT });
    }
}

export default function*() {
    yield takeLatest(
        ActionTypeConstants.REVOKE_USER_ACCESS,
        RevokeUserAccessSaga
    );
}
